// Composer-style /command at line start or after whitespace (not URL path segments) — see AI-1490.
const COMPOSER_SLASH_IN_MESSAGE_RE = /(?:^|[\s])\/([a-z][a-z0-9-]*)/gm;

export type SlashEmphasisPart = { kind: 'plain' | 'strong'; text: string };

// Kept in sync with extractSlashCommandsFromMessage: avoids bolding /bw inside https://.../bw.
export function splitTextForSlashCommandEmphasis(text: string): SlashEmphasisPart[] {
  const out: SlashEmphasisPart[] = [];
  let last = 0;

  for (const m of text.matchAll(COMPOSER_SLASH_IN_MESSAGE_RE)) {
    const name = m[1];

    if (name === undefined) {
      continue;
    }

    const i = m.index ?? 0;
    const full = m[0];

    if (i > last) {
      out.push({ kind: 'plain', text: text.slice(last, i) });
    }
    const slash = `/${name}`;
    const prefix = full.slice(0, full.length - slash.length);

    if (prefix) {
      out.push({ kind: 'plain', text: prefix });
    }
    out.push({ kind: 'strong', text: slash });
    last = i + full.length;
  }

  if (last < text.length) {
    out.push({ kind: 'plain', text: text.slice(last) });
  }

  return out;
}

export function extractSlashCommandsFromMessage(message: string): Set<string> {
  const commands = new Set<string>();

  for (const m of message.matchAll(COMPOSER_SLASH_IN_MESSAGE_RE)) {
    if (m[1]) {
      commands.add(m[1]);
    }
  }

  return commands;
}
